import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { VersionsService } from '@app/services/app/versions.service';
import { AppRouterService } from '@app/services/app/router.service';
import { AppService } from 'app/services/app/app.service';

import * as Objects from '@core/objects';
import { VersionShareItem } from '@core/models/version-share.model';
import { VersionSharesService } from '@core/services/version-shares/version-shares.service';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { VersionListItemMenuClick } from '@core/components/versions/list/version-list-item-menu-click';

@Component({
    selector: 'project-add-origin-version',
    templateUrl: './origin-version.component.html',
    styleUrls: ['./origin-version.component.scss']
})
export class ProjectAddOriginVersionComponent implements OnInit, OnDestroy {
    protected readonly ACCESS_REQUEST_FEEDBACK = 'share_feedback';

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_ALLOWED = 2;

    @Input() version: Objects.Version = null;
    
    public feedbackPluginAccess: boolean = false;
    public feedbacks: Array<VersionShareItem> = null;
    
    public menu: Array<ThreeDotsMenuItem> = [
        {
            title: "See Artwork Details",
            key: "details",
            icon: "see-details"
        }
    ];


    public status: number = this.STATUS_LOADING;
    protected subscriptor: Subscription;
    protected feedbacksSubscriptor: Subscription; 

	constructor(private versionSharesSrv: VersionSharesService, private appRouter: AppRouterService,private app: AppService,private versionsSrv: VersionsService){}

	ngOnInit(){
        // get plugins access
        this.subscriptor = this.app.getSession().subscribe( (session: any) => {
            this.feedbackPluginAccess = session.options.plugins.some((pa) => pa == this.ACCESS_REQUEST_FEEDBACK);
            this.initView();
        });

        this.initView();

        
	}

    ngOnDestroy(): void {
        this.subscriptor.unsubscribe();
        if(this.feedbacksSubscriptor)
            this.feedbacksSubscriptor.unsubscribe();
    }

    initView(){
        // feedback needs an array of versions!!
        if(this.version != null){
            this.status = this.STATUS_DONE;
            this.initFeedbacks([this.version]);
        }
    }

    public getFeedbacks(version: Objects.Version){
        return this.feedbacks != null ? this.feedbacks.filter((f: VersionShareItem) => f.version.id == version.id) : null;
    }

    onMenuClick(menu: VersionListItemMenuClick) {
        // console.debug(" menu original click",menu.key);
        switch(menu.key) {
            case "details":
                // navigate without clean add project form
                // url to go to Artwork Details
                this.appRouter.navigate("/versions/"+this.version.id);
                break;
        }
    }

    onFileClick(file: Objects.File){
        if (file != null){
            // url to preview Artwork FILE
            this.appRouter.navigate("/versions/"+this.version.id + "/files/"+file.id);
        }
    }
    
    protected initFeedbacks(versions: Array<Objects.Version>) {
        if(!this.feedbackPluginAccess) {
            this.feedbacks = [];
            return;
        }

        // @deprecated oct-2026: legacy share feedback bubbles url call, replaced by VersionSharesService.getVersionShareItems$
        // this.feedbacksSubscriptor = this.versionsSrv.getFeedbacks$(versions).subscribe((feedbacks: Array<VersionShareItem>) => {
        this.feedbacksSubscriptor = this.versionSharesSrv.getVersionShareItems$(versions).subscribe((feedbacks: Array<VersionShareItem>) => {
                this.feedbacks = feedbacks;
        });
    }

}
